import React from "react";
import { MutationOrNetworkState } from "../../../common/models/NetworkRequest";
import { RequestWorkflowTab, WorkflowSetupTabs } from "./WorkflowSetupTabs";
import { usePrimaryOrganizationId } from "../../hooks";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import {
  ProgressFooter,
  ProgressFooterActions,
  ProgressFooterSaveNotification,
} from "../get-compliant/ProgressFooter";
import { TopNavigationBreadcrumb } from "../../components/privacyCenter/TopNavigationBreadcrumb";
import { useOnboardingProgress } from "../../../common/hooks/useOnboardingProgress";

export function WorkflowSetupPageWrapper({
  selectedTabKey,
  alwaysShowFooter,
  nextOnClick,
  nextContent,
  nextDisabled,
  nextDisabledTooltip,
  isSaving,
  saveRequest,
  children,
  hideFooter,
}: {
  selectedTabKey: RequestWorkflowTab;
  alwaysShowFooter?: boolean;
  nextOnClick: () => void;
  nextContent?: string;
  nextDisabled: boolean;
  nextDisabledTooltip?: string;
  isSaving?: boolean;
  saveRequest?: MutationOrNetworkState | MutationOrNetworkState[];
  children: React.ReactNode;
  hideFooter?: boolean;
}) {
  const orgId = usePrimaryOrganizationId();

  const [onboardingProgress] = useOnboardingProgress(orgId);

  const {
    workflowsSetupOnboardingProgress: {
      isFinishedWorkflowSetupOnboarding = false,
      isLimitSettingsComplete = false,
    },
  } = onboardingProgress || {};

  return (
    <StandardPageWrapper
      fullWidth
      footer={
        (!isFinishedWorkflowSetupOnboarding || alwaysShowFooter) && (
          <ProgressFooter
            content={isSaving && <ProgressFooterSaveNotification request={saveRequest} />}
            actions={
              hideFooter !== true && (
                <ProgressFooterActions
                  nextContent={nextContent || "Next Workflow"}
                  nextOnClick={nextOnClick}
                  nextDisabled={nextDisabled}
                  nextDisabledTooltip={nextDisabledTooltip}
                />
              )
            }
          />
        )
      }
    >
      <div className="tw-boundary" style={{ marginBottom: "32px" }}>
        <TopNavigationBreadcrumb title="Workflow Setup" source="DSAR Workflows" />

        <WorkflowSetupTabs
          selectedTabKey={selectedTabKey}
          enableNextTab={!nextDisabled}
          enableAllTabs={isFinishedWorkflowSetupOnboarding}
          // Also check `isFinishedWorkflowSetupOnboarding` because we don't want the yellow dot to appear during onboarding
          isLimitStepIncomplete={!isLimitSettingsComplete && isFinishedWorkflowSetupOnboarding}
        />
      </div>

      {children}
    </StandardPageWrapper>
  );
}
